module.exports = {
    MANIFEST_NAME: "MSAT",
    MANIFEST_SHORT_NAME: "MSAT"
};
